import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';

type Props = PropsWithChildren<{
  title: string;
  value: string;
}>;

export const SettingsPanelAccordionItem = ({ children, title, value }: Props) => {
  return (
    <Accordion.Item value={value}>
      <Accordion.Header title={title} />
      <Accordion.Body
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(1),
          paddingTop: theme.spacing(0.5),
        }}
      >
        {children}
      </Accordion.Body>
    </Accordion.Item>
  );
};
